import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { SWATCH_SIZE_COMPACT, SWATCH_SIZE_FULL } from "../constants.js";
const SIZE_FULL = `calc(${SWATCH_SIZE_FULL} - ${SpaceXxs} * 2)`;
const SIZE_COMPACT = `calc(${SWATCH_SIZE_COMPACT} - ${SpaceXxs} * 2)`;
const containerStyles = {
  backgroundPosition: "center",
  border: "0px",
  borderRadius: "2px",
  cursor: "pointer",
  height: "100%",
  minHeight: SIZE_FULL,
  minWidth: SIZE_FULL,
  position: "relative",
  width: "100%"
};
const containerCompactStyles = {
  minHeight: `${SIZE_COMPACT} !important`,
  minWidth: `${SIZE_COMPACT} !important`
};
export {
  containerCompactStyles,
  containerStyles
};
